module.exports = __webpack_public_path__ + "static/media/varada.41f3db75.png";